/**
 * event list 의 on-instantplay 컨버팅 중 신 규격 context-action-list 의 url 에서 contentid 와 contenttype 을 추출
 * (e.g)
 * url: '/player/${context_type}.html?${additional_information.play_url}'
 * return: { contentId: '${context_id}', contentType: '${context_type}' }
 * @param url
 * @returns {{contentId: string, contentType: string}}
 */
export const getContentIdType = (url = '') => {
  if (url === '') return { contentId: '', contentType: '' }

  const regExp = /\$\{[^}]+}/gi
  const match = url.match(regExp)

  if (!match) return { contentId: '', contentType: '' }

  const [contentType, contentId] = match

  return {
    contentId,
    contentType,
  }
}
